import api from './api';

const glassesOrderService = {
    // Eye doctor: send a visit's glasses prescription to the optician. One order
    // per visit - sending again updates it.
    sendFromVisit: async (visitId) => {
        const response = await api.post(`/glasses-orders/visit/${visitId}`);
        return response.data;
    },

    // The glasses orders of one patient, with how far along each is.
    getForPatient: async (patientId) => {
        const response = await api.get(`/glasses-orders/patient/${patientId}`);
        return response.data;
    },

    // ===== Optician queue =====
    // status: 'open' (default), one of the order statuses, or 'all'
    getOrders: async (status = 'open') => {
        const response = await api.get('/glasses-orders', { params: { status } });
        return response.data;
    },

    updateStatus: async (id, data) => {
        const response = await api.put(`/glasses-orders/${id}/status`, data);
        return response.data;
    }
};

export default glassesOrderService;
